import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";
import { timesheetList } from "constants/timesheet";

export const getTimeSheetList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.timesheet_list(pageNum, filters);
    dispatch({ type: timesheetList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: timesheetList,
      payload: error?.response?.data || error,
    });
  }
};

export const getTimeSheetById = async (id) => {
  try {
    const res = await API.get_timesheet_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateTimesheetStatus = async (id, bodyData) => {
  try {
    const res = await API.update_timesheet_status(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateRecordsById = async (id, bodyData) => {
  try {
    const res = await API.edit_lhbRecords_by_Id(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteLhbRecordById = async (id) => {
  try {
    const res = await API.delete_lhb_record_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//add lhb records
export const addLhbRecord = async (bodyData) => {
  try {
    const res = await API.add_lhb_record(bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}
